<template>
  <fieldset class="account__form-section">
    <legend class="account__form-section-title layout--margin-bottom-xs">
      Email Address
    </legend>
    <p class="input-group__directions">
      <i
        >Your email address is your username to log in and is where your
        receipts go.</i
      >
    </p>
    <strong class="text-size-sm">Current Email</strong>
    <p
      class="layout--margin-top-none layout--margin-bottom-sm layout--margin-top-xs"
    >
      <font-awesome-icon
        icon="check"
        class="icon--blue icon icon--small layout--margin-right-xxs"
      />{{ email }}
    </p>
    <p class="input-group__section-label">Change Email</p>
    <div class="input-group__wrap">
      <div class="input-group__field-wrap">
        <label for="newEmail" class="input-group__label">New Email</label>
        <input
          id="newEmail"
          maxlength="128"
          class="input-group__input"
          :class="{
            'input-group__input--error':
              $v.newEmail.$invalid && $v.newEmail.$dirty,
          }"
          v-model="newEmail"
          @change="handleChange"
          aria-required="true"
          :aria-invalid="$v.newEmail.$invalid && $v.newEmail.$dirty"
        />
        <Error
          :invalid="!$v.newEmail.required && $v.newEmail.$dirty"
          message="Please enter an email address"
        />
        <Error
          :invalid="!$v.newEmail.email && $v.newEmail.$dirty"
          message="Please enter a valid email"
        />
        <Error
          :invalid="!$v.newEmail.maxLength && $v.newEmail.$dirty"
          message="Email must be 128 characters or less"
        />
      </div>
      <div class="input-group__field-wrap">
        <label for="reEnterNewEmail" class="input-group__label"
          >Confirm New Email</label
        >
        <input
          id="reEnterNewEmail"
          maxlength="128"
          class="input-group__input"
          :class="{
            'input-group__input--error':
              $v.reEnterNewEmail.$invalid && $v.reEnterNewEmail.$dirty,
          }"
          v-model="reEnterNewEmail"
          @change="handleChange"
          aria-required="true"
          :aria-invalid="
            $v.reEnterNewEmail.$invalid && $v.reEnterNewEmail.$dirty
          "
        />
        <Error
          :invalid="!$v.reEnterNewEmail.required && $v.reEnterNewEmail.$dirty"
          message="Please re-enter the email address"
        />
        <Error
          :invalid="
            !$v.reEnterNewEmail.sameAsNewEmail && $v.reEnterNewEmail.$dirty
          "
          message="Email address does not match."
        />
        <Error
          :invalid="!$v.reEnterNewEmail.email && $v.reEnterNewEmail.$dirty"
          message="Please enter a valid email"
        />
        <Error
          :invalid="!$v.reEnterNewEmail.maxLength && $v.reEnterNewEmail.$dirty"
          message="Email must be 128 characters or less"
        />
      </div>
    </div>
    <LoadingButton
      :event="saveNewEmail"
      :loading="$wait.is('saving email')"
      :doneLoading="saved"
      label="Change Email"
    />
  </fieldset>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { mapWaitingActions } from "vue-wait";
import { required, sameAs, email, maxLength } from "vuelidate/lib/validators";

import LoadingButton from "../../../components/LoadingButton";
import Error from "../../../components/Error";

const formSection = "Your Email";
const formFields = [
  {
    field: "credentials_Email",
    section: "userDto",
  },
];

export default {
  name: "YourEmail",
  components: {
    LoadingButton,
    Error,
  },
  data() {
    return {
      newEmail: "",
      reEnterNewEmail: "",
      formSection,
      saved: false,
    };
  },
  computed: {
    ...mapGetters("account", ["user", "email"]),
    ...mapGetters("forms", ["formSectionChanged"]),
  },
  methods: {
    ...mapWaitingActions("account", { saveData: "saving email" }),
    saveNewEmail: function() {
      // touch the email fields so they display relevent errors if needed
      this.$v.newEmail.$touch();
      this.$v.reEnterNewEmail.$touch();
      // if the new email is valid, save it and reset $touch properties
      if (!this.$v.newEmail.$invalid && !this.$v.reEnterNewEmail.$invalid) {
        this.saved = false;
        const formFields = [
          {
            field: "credentials_Email",
            value: this.newEmail,
            section: "userDto",
          },
        ];
        this.saveData(formFields).then(() => {
          this.$v.newEmail.$reset();
          this.$v.reEnterNewEmail.$reset();
          this.saved = true;
        });
      }
    },
    handleChange: function() {
      this.saved = false;
    },
  },
  validations: {
    newEmail: {
      required,
      email,
      maxLength: maxLength(128),
    },
    reEnterNewEmail: {
      required,
      email,
      sameAsNewEmail: sameAs("newEmail"),
      maxLength: maxLength(128),
    },
  },
};
</script>

<style></style>
